module.exports = __webpack_public_path__ + "static/media/black-delete.d658fb0a.svg";